<div
  style="position: absolute; left: 0; right: 0; top: 0; z-index: 4"
  *ngFor="let alert of alerts"
  class="{{ cssClass(alert) }}"
>
  <a class="close" (click)="removeAlert(alert)">&times;</a>
  <span [innerHTML]="alert.message"></span>
</div>
